<template>
  <div class="modal-content">
    <div class="modal-header">
      <button type="button"
              class="close"
              @click="closeModal">
        <span aria-hidden="true">x</span>
        <span class="sr-only">Close</span>
      </button>
      <h2 class="font-bold">Véhicule non vendu</h2>
      <p class="m-t-md">Dommage !</p>
      <p>Le rendez-vous n’a finalement pas eu lieu à l’heure prévue, il doit être planifié ultérieurement.</p>
    </div>
    <div class="modal-body">
      <div class="row text-center animated fadeInDown">
        <div class="col-lg-12">
          <div class="m-b-md">
            <div class="m-t-md middle-box">
              <div class="row">
                <div class=" m-b">
                  <div class="m-t">
                    <div class="col-lg-8 col-xs-8 text-left m-b-lg font-bold">Le partenaire s’est-il déplacé au rendez-vous initialement prévu ?</div>
                    <div class="col-lg-4 col-xs-4">
                      <div class="pull-right response">
                        <div class="i-checks">
                          <label>
                            <input type="radio" value="true" name="a" v-model="hasExpertMoved"> <i></i> Oui
                          </label>
                        </div>
                        <div class="i-checks m-l">
                          <label>
                            <input type="radio" value="false" name="a" v-model="hasExpertMoved"> <i></i> Non
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-12 m-b-md">
                  <hr class="hr-line-dashed">
                  <p class="text-left font-bold">Veuillez préciser la/les raison(s) :</p>
                  <div class="m-t-md">
                    <h4 class="text-left"><i class="fa fa-user"></i> Identité / Document </h4>
                    <div class="m-t m-b-md text-left">
                      <div class="i-checks"><label> <input type="checkbox" value="1" v-model="reasons"> <i></i> Problème d’identité d’un client, ou procuration manquante</label></div>
                      <div class="i-checks"><label> <input type="checkbox" value="2" v-model="reasons"> <i></i> Erreur dans un document de cession</label></div>
                    </div>
                    <h4 class="text-left"> <i class="fa fa-flag-checkered"></i> Retard / imprévu </h4>
                    <div class="m-t text-left">
                      <div class="i-checks"><label> <input type="checkbox" value="3" v-model="reasons"> <i></i> Imprévu acheteur </label></div>
                      <div class="i-checks"><label> <input type="checkbox" value="4" v-model="reasons"> <i></i>Imprévu vendeur</label></div>
                      <div class="i-checks"><label> <input type="checkbox" value="5" v-model="reasons"> <i></i>Imprévu partenaire</label></div>
                    </div>
                  </div>
                  <div class="m-t-lg">
                    <h4 class="text-left"><i class="fa fa-globe"></i> Environnement </h4>
                    <div class="m-t text-left">
                      <div class="i-checks"><label> <input type="checkbox" value="6" v-model="reasons"> <i></i>  Intempéries </label></div>
                      <div class="i-checks"><label> <input type="checkbox" value="7" v-model="reasons"> <i></i>  Luminosité trop faible </label></div>
                    </div>
                    <h4 class="text-left"> Autre </h4>
                    <div class="m-t text-left">
                      <div class="i-checks"><label> <input type="checkbox" value="8" v-model="reasons" @click="showComment()"> <i></i>  Autre </label></div>
                      <textarea id="comment" v-model="otherReasonText" v-show="otherReason"></textarea>
                    </div>
                  </div>
                  <hr class="hr-line-dashed">
                  <div class="form-group comment">
                    <label class="control-label" for="comment">Commentaire</label>
                    <textarea id="comment" rows="3" cols="50" style="width:100%" v-model="comment"></textarea>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-12">
              <button type="button"
                      class="m-b-xl btn btn-default"
                      @click="closeModal">Annuler</button>
              <button type="submit"
                      :disabled="!canSave"
                      class="m-b-xl btn btn-primary"
                      @click="onConfirm">Enregistrer</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import store from '../../config/store'
  import gql from 'graphql-tag'

  export default {
    data: () => ({
      reasons: [],
      hasExpertMoved: null,
      otherReason: false,
      otherReasonText: "",
      comment: "",
      store
    }),

    computed: {
      model () {
        return store.modal.dataModel
      },

      sendReasonMutation() {
        return gql`
          mutation {
            replainAppointment(
              saleRdvId:"${this.model.saleRdvId}",
              reasons: [${this.reasons.map(x => '"' + x + '"')}],
              comment: "${this.comment}",
              hasExpertMoved: ${this.hasExpertMoved},
              otherReason: "${this.otherReasonText}"
            ) {
              result
            }
          }
        `
      },

      canSave () {
        if (this.reasons.length == 0) {
          return false
        }

        if (this.reasons.includes('8') && this.reasons.length == 1 && this.otherReasonText == '') {
          return false
        }

        if (this.hasExpertMoved == null) {
          return false
        }

        return true
      }
    },

    methods: {
      onConfirm () {
        this.$bus.$emit(`reason-confirm-success`)
        this.$apollo.mutate({
          mutation: this.sendReasonMutation
        }).then(() => {
          this.closeModal()
          this.showBanner('success', `Succès: le rendez-vous #${this.model.saleRdvId} a bien été annulé et sera replanifé`)
        }, () => {
          this.closeModal()
          this.showBanner('danger', `Le rendez-vous #${this.model.saleRdvId} n'a pas pu être annulé`)
        })
      },

      showComment() {
        this.otherReason = !this.otherReason
      }
    }
  }
</script>
